export enum FeatureFlag {
  IS_OTP_TOGGLING_ENABLED = 'portal_rollout_toggling_otp',
  ORDER_TYPE_PER_MERCHANT = 'order_type_per_merchant',
  IS_ACCESS_TYPE_CONTROLLED = 'portal_is_access_type_controlled',
  IS_SEGMENTATION_ENABLED = 'portal_is_segmentation_enabled',
  IS_ACCOUNT_ACTIVATION_ENABLED = 'portal_is_account_activation_enabled',
  IS_EMAIL_VERIFICATION_ENABLED = 'portal_is_email_verification_enabled',
  IS_CCOD_ENABLED = 'portal_is_ccod_enabled',
  IS_NEW_SIGN_IN_ENABLED = 'portal_is_new_sign_in_enabled',
  IS_DATA_MIGRATION_WARNING_ENABLED = 'portal_is_data_migration_warning_enabled',
  IS_SCHEDULED_ENABLED = 'portal_scheduled_enabled',
  IS_ESTIMATES_ENABLED = 'portal_estimates_enabled',
  IS_ZONE_VALIDATION_ENABLED = 'portal_is_zone_validation_enabled',
  IS_TRANSPORTER_TRACKING_ENABLED = 'portal_is_transporter_tracking_enabled',
  IS_NEW_INVOICES_API_ENABLED = 'portal_is_new_invoices_api_enabled',
  IS_NEW_CARDS_API_ENABLED = 'portal_is_new_cards_api_enabled',
  IS_LOCATIONS_REVERSE_GEOCODING_DISABLED = 'portal_is_locations_reverse_geocoding_disabled',
  IS_ONE_CLICK_DISABLED = 'portal_is_one_click_disabled',
  IS_BOOKING_FREE_ROUTE_ENABLED = 'is_booking_free_route_enabled',
  IS_ACTIVE_DELIVERIES_V2_ENABLED = 'portal_is_active_deliveries_v2_enabled',
  IS_PAYMENT_TYPE_IN_BOOKING_ENABLED = 'portal_is_payment_type_in_booking_enabled',
  IS_REQUEST_CAR_FOR_DELIVERY_ENABLED = 'portal_is_request_car_for_delivery_enabled',
  IS_CUSTOMER_NAME_REQUIRED_ENABLED = 'portal_is_customer_name_required_enabled',
  IS_DOWNLOAD_RECORDS_ENABLED = 'portal_is_download_records_enabled',
  IS_CONTACT_SUPPORT_ENABLED = 'portal_is_contact_support_enabled'
}
